// extracted by mini-css-extract-plugin
module.exports = {"modal":"typeform-modal_modal__Ad2zM","typeform":"typeform-modal_typeform__XZWEt","close":"typeform-modal_close__6EfsY"};